<template>
  <custom-select
    v-model="ageChild"
    placeholder="Enter Children’s Ages"
    :options="ageOptions"
    :class="{ 'enter-child-ages': getSelectedRoomDetails.length }"
  />
</template>

<script>
import CustomSelect from "../../core/CustomSelect";
import { mapGetters } from "vuex";

export default {
  components: {
    CustomSelect,
  },
  props: ["child", "roomId"],
  data() {
    const ageOptions = [];
    for (let i = 1; i < 18; i++) {
      ageOptions.push({ label: i, value: i });
    }
    return {
      ageOptions,
    };
  },
  computed: {
    ...mapGetters(["getSelectedRoomDetails"]),
    ageChild: {
      get() {
        return this.child.age;
      },
      set(val) {
        const value = { roomId: this.roomId, id: this.child.id, age: val };
        this.$store.commit("setAgeChild", value);
      },
    },
  },
};
</script>

<style scoped>
.enter-child-ages ::v-deep .mobile-select-list {
  margin-bottom: 60px;
}
</style>
